import React from 'react';
import { getFullDate } from '../../commons/CommonMethods';
import Button from '../../ComponentsV1/Button';
import { CopyText } from '../../../UiKit';

export const userZMoneyHeadings = [
  { name: 'Amount', key: 1 },
  { name: 'Description', key: 2 },
  { name: 'Transaction ID', key: 3 },
  { name: 'Status', key: 4 },
  { name: 'Action', key: 5 },
  { name: 'Refund Status', key: 6 },
];

export const BmoneySkeletonRows = [
  { cols: 2, height: '7rem' },
  { cols: 1, height: '100rem' },
];

export const REFUND_ENTITY = {
  WALLET: 'WALLET',
  TRANSACTION: 'TRANSACTION',
};

export const BMONEY_API = {
  REFUND_WALLET: 'user/refund_bmoney_wallet',
  REFUND_TRANSACTION: 'user/refund_bmoney_transaction',
};

const getTransactionsObj = (transaction, setpopupData, isRefundAllowed) => {
  const {
    transaction_status_color,
    display_amount,
    created_at,
    display_text,
    display_subtext,
    txn_id,
    transaction_status,
    is_refundable,
    refund_status,
    refund_status_color,
  } = transaction || {};

  return {
    1: {
      title:
        (
          <span
            className={`${
              display_amount?.toLowerCase()?.includes('+')
                ? 'tw-text-base-green'
                : 'tw-text-red-600'
            } tw-font-medium tw-text-[1.5rem]`}
          >
            {display_amount}
          </span>
        ) || '-',
      subTitle: (
        <span className='tw-font-regular tw-leading-none !tw-text-[1.3rem] tw-text-zinc-500'>
          {getFullDate(created_at * 1000) || '-'}
        </span>
      ),
    },
    2: {
      title: (
        <span className='tw-font-medium !tw-text-[1.4rem] tw-text-grey-800 tw-uppercase'>
          {(display_text || '-').toUpperCase()}
        </span>
      ),
      subTitle: display_subtext ? (
        <span className='tw-font-regular tw-leading-none !tw-text-[1.3rem] tw-text-zinc-500'>
          {display_subtext || ''}
        </span>
      ) : null,
    },
    3: {
      title: (
        <span
          className='tw-border-solid tw-p-2 tw-rounded-lg tw-border-grey-300/70 tw-bg-grey-100/50 tw-leading-none tw-whitespace-nowrap'
          data-dd-privacy='mask'
        >
          <CopyText
            title={txn_id || '-'}
            customClass='tw-font-medium !tw-text-[1.3rem] !tw-text-grey-800'
          />
        </span>
      ),
    },
    4: {
      title: (
        <div
          style={{ color: transaction_status_color }}
          className='tw-font-medium tw-text-[1.4rem]'
        >
          {transaction_status || '-'}
        </div>
      ),
    },
    5: {
      title:
        is_refundable && isRefundAllowed ? (
          <Button
            title={'Refund'}
            onClick={() => {
              setpopupData({
                isVisible: true,
                popupTitle: (
                  <span className='tw-text-[1.8rem] tw-flex tw-items-center tw-gap-3'>
                    Refund Transaction:
                    <span className='tw-text-base-green tw-leading-none tw-text-[1.8rem]'>
                      {display_amount}
                    </span>
                  </span>
                ),
                txnId: txn_id,
                refundEntity: REFUND_ENTITY.TRANSACTION,
              });
            }}
          />
        ) : (
          '-'
        ),
    },
    6: {
      title: (
        <div
          style={{ color: refund_status_color }}
          className='tw-font-medium tw-text-[1.4rem]'
        >
          {refund_status || '-'}
        </div>
      ),
    },
  };
};

export const getUserTxnRows = (transactions, setpopupData, isRefundAllowed) => {
  if (!transactions) {
    return [];
  }

  const rowsData = transactions.map((transaction) => {
    return getTransactionsObj(transaction, setpopupData, isRefundAllowed);
  });
  return rowsData;
};
